{
  "familyId": "GET-KOMMA-VERGELIJK",
  "questions": [
    {
      "id": "GET-KOMMA-VERGELIJK-001",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het grootst: 0,8 of 0,53?",
      "options": [
        "0,8",
        "0,53",
        "ze zijn gelijk",
        "dat kun je niet vergelijken"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_vergelijk_tienden_honderdsten",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: maak het aantal cijfers achter de komma gelijk. Stap 1: 0,8 = 0,80 (voeg een nul toe). Stap 2: Vergelijk nu: 0,80 en 0,53. Stap 3: 80 honderdsten > 53 honderdsten. Stap 4: Dus 0,8 > 0,53.",
        "distractorExplanations": {
          "0": "Goed! 0,8 = 0,80 = 80 honderdsten. Dat is meer dan 0,53 = 53 honderdsten.",
          "1": "Veelgemaakte fout: denken dat meer cijfers achter de komma = groter getal. 0,53 heeft twee cijfers achter de komma, maar 53 honderdsten < 80 honderdsten (= 0,8). Maak eerst het aantal cijfers gelijk!",
          "2": "De getallen zijn niet gelijk. 0,8 = 80 honderdsten en 0,53 = 53 honderdsten. 80 ≠ 53.",
          "3": "Je kunt kommagetallen altijd vergelijken. Maak het aantal cijfers achter de komma gelijk door nullen toe te voegen, en vergelijk dan."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-002",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Zet in de juiste volgorde van klein naar groot: 1,5 — 1,05 — 1,50",
      "options": [
        "1,05 — 1,5 — 1,50",
        "1,5 — 1,05 — 1,50",
        "1,50 — 1,05 — 1,5",
        "1,50 — 1,5 — 1,05"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_ordenen_gelijk",
      "variantIndex": 2,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 1,5 = 1,50 en 1,05 = 1,05. Vergelijk nu: 1,05 heeft 5 honderdsten, 1,50 heeft 50 honderdsten. Dus 1,05 is het kleinst. Let op: 1,5 en 1,50 zijn precies gelijk — de extra nul verandert de waarde niet. Volgorde: 1,05 — 1,5 — 1,50.",
        "distractorExplanations": {
          "0": "Goed! 1,05 (5 honderdsten) is het kleinst. 1,5 en 1,50 zijn gelijk (allebei 50 honderdsten). De volgorde 1,05 — 1,5 — 1,50 is correct.",
          "1": "Je dacht waarschijnlijk dat 1,5 kleiner is dan 1,05 omdat 5 kleiner is dan 05. Maar maak het gelijk: 1,5 = 1,50 = 50 honderdsten, en 1,05 = 5 honderdsten. 50 is meer dan 5, dus 1,5 is groter dan 1,05. Onthoud: voeg eerst een nul toe zodat je eerlijk vergelijkt.",
          "2": "Je dacht waarschijnlijk dat 1,50 het kleinste getal is. Maar 1,50 = 1,5 — ze zijn gelijk. Het kleinste getal is 1,05. Onthoud: een extra nul achter de komma verandert de waarde niet.",
          "3": "Dit is de volgorde van groot naar klein. De vraag vraagt van klein naar groot. Begin bij het kleinste getal: 1,05."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-003",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk teken hoort er: 2,45 ○ 2,5?",
      "options": [
        "<",
        ">",
        "=",
        "≠"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_vergelijk_teken",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: maak het aantal cijfers achter de komma gelijk. Stap 1: 2,45 blijft 2,45. Stap 2: 2,5 = 2,50. Stap 3: Vergelijk: 2,45 en 2,50. Stap 4: 45 honderdsten < 50 honderdsten. Stap 5: Dus 2,45 < 2,50 → het teken is <.",
        "distractorExplanations": {
          "0": "Goed! 2,45 < 2,50 (= 2,5). 45 honderdsten is minder dan 50 honderdsten.",
          "1": "Veelgemaakte fout: denken dat 2,45 > 2,5 omdat 45 > 5. Maar je moet het aantal cijfers gelijk maken: 2,45 vs 2,50. Dan zie je: 45 < 50.",
          "2": "De getallen zijn niet gelijk. 2,45 = 245 honderdsten en 2,5 = 250 honderdsten. 245 ≠ 250.",
          "3": "Het teken ≠ (niet gelijk) klopt wel, maar is niet het meest precieze antwoord. De vraag vraagt welk teken ertussen hoort: < geeft de exacte relatie aan."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-004",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal ligt het dichtst bij 3?",
      "options": [
        "2,95",
        "3,1",
        "2,8",
        "3,15"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_dichtst_bij",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Strategie: bereken het verschil met 3 voor elk getal. Stap 1: |3 − 2,95| = 0,05. Stap 2: |3 − 3,1| = 0,1. Stap 3: |3 − 2,8| = 0,2. Stap 4: |3 − 3,15| = 0,15. Stap 5: 0,05 is het kleinste verschil, dus 2,95 ligt het dichtst bij 3.",
        "distractorExplanations": {
          "0": "Goed! 2,95 verschilt maar 0,05 van 3. Dat is het kleinste verschil van alle opties.",
          "1": "3,1 verschilt 0,1 van 3. Dat is meer dan 0,05 (het verschil van 2,95). Hoewel 3,1 boven 3 ligt, is het verschil groter.",
          "2": "2,8 verschilt 0,2 van 3. Dat is veel meer dan 0,05. 2,8 ligt verder van 3 af dan 2,95.",
          "3": "3,15 verschilt 0,15 van 3. Dat is meer dan 0,05. 3,15 ligt verder van 3 af dan 2,95."
        }
      }
    },
    {
      "id": "GET-KOMMA-VERGELIJK-005",
      "familyId": "GET-KOMMA-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 6,
      "levelCode": "E6+",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "komma_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welk getal is het kleinst: 0,4 — 0,09 — 0,41 — 0,1?",
      "options": [
        "0,09",
        "0,1",
        "0,4",
        "0,41"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_kleinste_vinden",
      "variantIndex": 5,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: maak alle getallen even lang achter de komma. Stap 1: 0,4 = 0,40; 0,09 = 0,09; 0,41 = 0,41; 0,1 = 0,10. Stap 2: Vergelijk de honderdsten: 40, 09, 41, 10. Stap 3: 09 is het kleinst. Stap 4: Dus 0,09 is het kleinste getal.",
        "distractorExplanations": {
          "0": "Goed! 0,09 = 9 honderdsten. Dat is kleiner dan 0,10 (10 honderdsten), 0,40 (40 honderdsten) en 0,41 (41 honderdsten).",
          "1": "0,1 = 0,10 = 10 honderdsten. Dat is groter dan 0,09 = 9 honderdsten. Hoewel 1 > 9 lijkt, moet je het aantal cijfers gelijk maken: 10 > 09.",
          "2": "0,4 = 0,40 = 40 honderdsten. Dat is veel groter dan 0,09 = 9 honderdsten.",
          "3": "0,41 = 41 honderdsten. Dat is het grootste getal in de reeks, niet het kleinste."
        }
      }
    }
  ]
}